export const FETCH_ME_REQUEST = 'FETCH_ME_REQUEST'
export const FETCH_ME_SUCCESS = 'FETCH_ME_SUCCESS'
export const FETCH_ME_FAILURE = 'FETCH_ME_FAILURE'
export const FETCH_CREDIT_CARD = 'FETCH_CREDIT_CARD'
export const FETCH_CREDIT_CARD_REQUEST = `${FETCH_CREDIT_CARD}_REQUEST`
export const FETCH_CREDIT_CARD_SUCCESS = `${FETCH_CREDIT_CARD}_SUCCESS`
export const FETCH_CREDIT_CARD_FAILURE = `${FETCH_CREDIT_CARD}_FAILURE`
export const ADD_CREDIT_CARD = 'ADD_CREDIT_CARD'
export const ADD_CREDIT_CARD_REQUEST = `${ADD_CREDIT_CARD}_REQUEST`
export const ADD_CREDIT_CARD_SUCCESS = `${ADD_CREDIT_CARD}_SUCCESS`
export const ADD_CREDIT_CARD_FAILURE = `${ADD_CREDIT_CARD}_FAILURE`
export const FETCH_WALLET_RECORDS = 'FETCH_WALLET_RECORDS'
export const FETCH_WALLET_RECORDS_REQUEST = `${FETCH_WALLET_RECORDS}_REQUEST`
export const FETCH_WALLET_RECORDS_SUCCESS = `${FETCH_WALLET_RECORDS}_SUCCESS`
export const FETCH_WALLET_RECORDS_FAILURE = `${FETCH_WALLET_RECORDS}_FAILURE`
export const FETCH_WALLET_RECORDS_END = `${FETCH_WALLET_RECORDS}_END`
export const ADD_WALLET_VALUE = 'ADD_WALLET_VALUE'
export const ADD_WALLET_VALUE_REQUEST = `${ADD_WALLET_VALUE}_REQUEST`
export const ADD_WALLET_VALUE_SUCCESS = `${ADD_WALLET_VALUE}_SUCCESS`
export const ADD_WALLET_VALUE_FAILURE = `${ADD_WALLET_VALUE}_FAILURE`
export const SET_WALLET_BALANCE = 'SET_WALLET_BALANCE'

export const fetchMe = () => {
  return {
    type: FETCH_ME_REQUEST,
  }
}

export const fetchCreditCards = () => {
  return {
    type: FETCH_CREDIT_CARD_REQUEST,
  }
}

export const addCreditCard = (cardToken) => {
  return {
    type: ADD_CREDIT_CARD_REQUEST,
    cardToken,
  }
}

export const fetchWalletRecords = (offset) => {
  return {
    type: FETCH_WALLET_RECORDS_REQUEST,
    offset,
  }
}

export const addWalletValue = (cardId, amount) => {
  return {
    type: ADD_WALLET_VALUE_REQUEST,
    cardId,
    amount,
  }
}
